
const apiConstants = ()=>{
  if (window.envType === 'DEV') {
    return {
      // DASHBOARD_API_URL: "https://qek2ydb6zc.execute-api.ap-south-1.amazonaws.com/public/",
      // PROPOSEL_API_URL: "https://dsgb9c6946.execute-api.ap-south-1.amazonaws.com/public/",
      // BAXA_API_URL: "https://c84odzdpt1.execute-api.ap-south-1.amazonaws.com/public/",
      // M_CUSTOMER_URL: 'https://dev.bhartiaxa.tk/mcustomer/',
      // AUTH_API_URL: 'https://tpfrdk01sc.execute-api.ap-south-1.amazonaws.com/public/',
      // DOCUMENT_API_URL: "https://u83a4awj7l.execute-api.ap-south-1.amazonaws.com/public/",

      DASHBOARD_API_URL: "https://dev-api-tracker.bhartiaxa.com/public/",
      PROPOSEL_API_URL: "https://dev-api-proposal.bhartiaxa.com/public/",
      BAXA_API_URL: "https://dev-api-integeration.bhartiaxa.com/public/",
      M_CUSTOMER_URL: 'https://dev-onboarding.bhartiaxa.com/mcustomer',
      AUTH_API_URL: 'https://dev-api-auth.bhartiaxa.com/public/',
      DOCUMENT_API_URL: "https://dev-api-document.bhartiaxa.com/public/",

      //     DASHBOARD_API_URL: "https://api-tracker.bhartiaxa.com/public/",
      // PROPOSEL_API_URL: "https://api-proposal.bhartiaxa.com/public/",
      // BAXA_API_URL: "https://api-integration.bhartiaxa.com/public/",
      // M_CUSTOMER_URL: 'https://onboarding.bhartiaxa.com/mcustomer',
      // AUTH_API_URL: 'https://api-auth.bhartiaxa.com/public/',
      // DOCUMENT_API_URL: "https://api-document.bhartiaxa.com/public/"
      
    }
  }
  else if (window.envType === 'UAT') {
    return{
      // DASHBOARD_API_URL: "https://kumto90d9e.execute-api.ap-south-1.amazonaws.com/uat/",
      // PROPOSEL_API_URL: "https://x6wab6dgmd.execute-api.ap-south-1.amazonaws.com/uat/",
      // BAXA_API_URL: "https://6ztjbcg9k9.execute-api.ap-south-1.amazonaws.com/uat/",
      // M_CUSTOMER_URL: 'https://uat.bhartiaxa.tk/mcustomer/',
      // AUTH_API_URL: 'https://id2hs3de2e.execute-api.ap-south-1.amazonaws.com/uat/',
      // DOCUMENT_API_URL: "https://c1lutfj4hd.execute-api.ap-south-1.amazonaws.com/uat/",

      DASHBOARD_API_URL: "https://uat-api-tracker.bhartiaxa.com/public/",
      PROPOSEL_API_URL: "https://uat-api-proposal.bhartiaxa.com/public/",
      BAXA_API_URL: "https://uat-api-integeration.bhartiaxa.com/public/",
      M_CUSTOMER_URL: 'https://uat-onboarding.bhartiaxa.com/mcustomer',
      AUTH_API_URL: 'https://uat-api-auth.bhartiaxa.com/public/',
      DOCUMENT_API_URL: "https://uat-api-document.bhartiaxa.com/public/",
    }
  }
  else if (window.envType === 'NEWGEN-UAT') {
    return{
      DASHBOARD_API_URL: "https://pphi-uat-api-tracker.bhartiaxa.com/public/",
      PROPOSEL_API_URL: "https://pphi-uat-api-proposal.bhartiaxa.com/public/",
      BAXA_API_URL: "https://pphi-uat-api-integeration.bhartiaxa.com/public/",
      M_CUSTOMER_URL: 'https://pphi-uat-onboarding.bhartiaxa.com/mcustomer',
      AUTH_API_URL: 'https://pphi-uat-api-auth.bhartiaxa.com/public/',
      DOCUMENT_API_URL: "https://pphi-uat-api-document.bhartiaxa.com/public/",
    }
  }
  else if (window.envType === 'PROD') {
    // return {
    //   DASHBOARD_API_URL: "https://zgd8doeosk.execute-api.ap-south-1.amazonaws.com/public/",
    //   PROPOSEL_API_URL: "https://b0pyrqwsui.execute-api.ap-south-1.amazonaws.com/public/",
    //   BAXA_API_URL: "https://f55bm57ole.execute-api.ap-south-1.amazonaws.com/public/",
    //   M_CUSTOMER_URL: 'https://onboarding.bhartiaxa.com/mcustomer',
    //   AUTH_API_URL: 'https://sidlce25m2.execute-api.ap-south-1.amazonaws.com/public/',
    //   DOCUMENT_API_URL: "https://yon81fbdwh.execute-api.ap-south-1.amazonaws.com/public/"
    // }
    return {
      DASHBOARD_API_URL: "https://api-tracker.bhartiaxa.com/public/",
      PROPOSEL_API_URL: "https://api-proposal.bhartiaxa.com/public/",
      BAXA_API_URL: "https://api-integration.bhartiaxa.com/public/",
      M_CUSTOMER_URL: 'https://onboarding.bhartiaxa.com/mcustomer',
      AUTH_API_URL: 'https://api-auth.bhartiaxa.com/public/',
      DOCUMENT_API_URL: "https://api-document.bhartiaxa.com/public/"
    }
  }
  else {
    return{
    DASHBOARD_API_URL:'https://qa-tracker-service.qa3.tothenew.net/',
    PROPOSEL_API_URL:'https://qa-proposal-service.qa3.tothenew.net/',
    BAXA_API_URL:'https://bharti-axa-integration.qa3.tothenew.net/',
    M_CUSTOMER_URL:'https://qa-mcustomer.qa3.tothenew.net/mcustomer/',
    AUTH_API_URL: 'https://bharti-axa-auth-qa.qa3.tothenew.net/',
    }   
  }
};
export default apiConstants;
